import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";
import ReportService from "../../../services/report-service/ReportService";
import moment from "moment";
import Utili from "../../../utility/Utility";
import SpinnerLoader from "../../../components/spinner-loader/SpinnerLoader.component";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

function MessageReport(props: any) {
  const getInitialDate = (days: number) => {
    var newDt = new Date();
    newDt.setDate(newDt.getDate() + days);
    return moment(newDt).format("YYYY-MM-DD");
  };
  const [selectedToDate, setSelectedToDate] = React.useState(getInitialDate(0));
  const [selectedFromDate, setSelectedFromDate] = React.useState(
    getInitialDate(-30)
  );
  const [maxDate, setMaxToDate] = React.useState(getInitialDate(0));
  const [validationMessage, setvalidationMessage] = React.useState("");
  const [isValidate, setIsValidate] = React.useState(false);
  const [selectedCaller, setSelectedCaller] = React.useState("Caller");
  const [RepType, setRepType] = React.useState(1);
  const [selectedCallType, setSelectedCallType] = React.useState("Missed");
  const classes = useStyles();
  const [reportData, setReportData] = useState("");
  const [pdfBytes, setpdfBytes] = useState("");
  useEffect(() => {
    //getRevenue();
  }, []);

  const handleFromDateChange = (date: any) => {
    console.log(date.target.value);
    setSelectedFromDate(date.target.value);
  };
  const handleToDateChange = (date: any) => {
    setSelectedToDate(date.target.value);
  };
  const getToDateString = (date: any) => {
    var time = "23:59:59";
    var newDt = moment(date + ' ' + time);
    return moment(newDt).format("MM/DD/YYYY hh:mm:ss A");
  };

  const getFromDateString = (date: any) => {
    var newDt = moment(new Date(date));
    return moment(newDt).format("MM/DD/YYYY");
  };
  const getDateFromString = (date: string) => {
    var newDt = new Date(date);

    return newDt;
  };
  const CurrentDate = () => {
    var currDate = new Date();
    return new Date(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate()
    );
  };
  const parseDate = (dt: Date) => {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  };
  const gettReport = () => {
    if (
      parseDate(getDateFromString(selectedFromDate)) > CurrentDate() ||
      parseDate(getDateFromString(selectedToDate)) > CurrentDate()
    ) {
      
      setIsValidate(true);
      setvalidationMessage("From Date and To Date cannot be in future");
      console.log("--------Date--------");
      const value = new Date(moment().format("MM/DD/YYYY"));
      console.log(moment().toDate().toDateString());
      console.log("From Date and To Date cannot be in future");
      return;
    }
 
    setIsValidate(false);
    setvalidationMessage("");
    const frmDate = selectedFromDate;
    const toDate = moment(selectedToDate + ' ' + "23:59:59").format('MM/DD/YYYY hh:mm:ss A');
    //?fromDate=0001-01-01&toDate=0001-01-01
    ReportService.getMessageCountReport(
      frmDate == "Invalid date" ? "0001-01-01" : frmDate,
      toDate == "Invalid date" ? "0001-01-01" : toDate,
      selectedCaller,
      RepType
    ).then((res: any) => {
      setReportData(res.data.result.reportHTML);
      setpdfBytes(res.data.result.reportBytes);
      setShowDownloadBtn(true);
    });
  };

  const ClearSearchCriteria = () => {
    setSelectedToDate(getInitialDate(0));
    setSelectedFromDate(getInitialDate(-30));
    setSelectedCaller("Caller");
    setSelectedCallType("Missed");
    setvalidationMessage("");
  };
  const handleChangeCallType = (event: any) => {
    debugger;
    if(event.target.value==="Missed") {
      setRepType(1);
    }
     if(event.target.value==="Accepted") {
      setRepType(0);
    }
    if(event.target.value==="Rejected") {
      setRepType(2);
    }
    setSelectedCallType(event.target.value);
  };
  const handleChangeCaller = (event: any) => {
    setSelectedCaller(event.target.value);
  };
  const Download = () => {
    var blob = Utili.b64toBlob(pdfBytes);
    var url = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = "MessageCountReport";
    a.click();
  };
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);
  return (
    <div className="col-12">
      <SpinnerLoader isGeneral={true} tasksList={
        ['getMessageCount']
      } inInternal={false} />
      <h3>Message Counts</h3>
      <div className="pt-2">
        <form className={classes.container} noValidate>
          <TextField
            id="dateFrom"
            label="From Date"
            type="date"
            value={selectedFromDate}
            onChange={handleFromDateChange}
            InputProps={{ inputProps: { max: selectedToDate } }}
            //defaultValue="0001-01-01" // 0001-01-01
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            id="dateTo"
            label="To Date"
            type="date"
            value={selectedToDate}
            onChange={handleToDateChange}
            InputProps={{ inputProps: { max: maxDate } }}
            //defaultValue="0001-01-01"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </form>
        <div className="">
          <div className="p-2 mt-2 mr-3 float-left">
            <div className="label-bx">
              <h5>User Type </h5>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="Caller"
                onChange={handleChangeCaller}
                checked={selectedCaller === "Caller"}
                id="Caller"
                name="role"
                className="custom-control-input"
              />
              <label className="custom-control-label" htmlFor="Caller">
                Sender
              </label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="Recipient"
                name="role"
                className="custom-control-input"
                value="Recipient"
                onChange={handleChangeCaller}
                checked={selectedCaller === "Recipient"}
              />
              <label className="custom-control-label" htmlFor="Recipient">
                Recipient
              </label>
            </div>
          </div>

          <div className="p-2 mt-2 float-left">
            <div className="label-bx">
              <h5>Message State </h5>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="Missed"
                onChange={handleChangeCallType}
                checked={selectedCallType === "Missed"}
                id="Missed"
                name="callType"
                className="custom-control-input"
              />
              <label className="custom-control-label" htmlFor="Missed">
                Pending
              </label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="Accepted"
                onChange={handleChangeCallType}
                checked={selectedCallType === "Accepted"}
                id="Accepted"
                name="callType"
                className="custom-control-input"
              />
              <label className="custom-control-label" htmlFor="Accepted">
                Completed
              </label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                value="Rejected"
                id="Rejected"
                onChange={handleChangeCallType}
                checked={selectedCallType === "Rejected"}
                name="callType"
                className="custom-control-input"
              />
              <label className="custom-control-label" htmlFor="Rejected">
                Expired
              </label>
            </div>
          </div>
          <div className="mt-4 float-left">
            <button
              color="secondary"
              onClick={ClearSearchCriteria}
              type="button"
              className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
            >
              Reset
            </button>
            <button
              color="secondary"
              onClick={gettReport}
              type="button"
              className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
            >
              View Report
            </button>
            <div className="clearfix"></div>
            <div>
              {isValidate && (
                <span className="error-msg" style={{ color: "#ff0000" }}>
                  {validationMessage}
                </span>
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <div className="clearfix"></div>
        </div>
        <div className="mt-4">
          <div className="mb-0 heading">
            <h5>
              Report{" "}
              {showDownloadBtn ? (
                <button
                  color="secondary"
                  onClick={Download}
                  type="button"
                  className="btn btn-sm btn-outline-secondary float-right"
                >
                  Save as
                </button>
              ) : (
                ""
              )}
            </h5>
          </div>
          <div className="report-view-bx">
            <div dangerouslySetInnerHTML={{ __html: reportData }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessageReport;
